import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { UnifiedProject, UnifiedProjectType } from '@shared/constants/models.const';
import { E_VIEWLET_TYPE } from '@shared/components/viewlet/viewlet.const';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { HelperService } from '../../../../../services/helper.service';
import { E_DATE_FORMAT } from '@shared/constants/enums.const';
import { GetStepPipe } from '@shared/components/viewlet/pipes/get-step.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-viewlet-tab',
  imports: [
    SafeHtmlPipe,
    GetStepPipe,
    TranslateModule,
  ],
  templateUrl: './viewlet-tab.component.html',
  styleUrl: './viewlet-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewletTabComponent {
  E_VIEWLET_TYPE = E_VIEWLET_TYPE;

  viewletType = input<E_VIEWLET_TYPE>();

  projects = input<UnifiedProject[]>([]);

  allProjects = input<UnifiedProjectType>({});

  flatProjects: Signal<UnifiedProject[]> = computed(() => {
    if (!this.allProjects()) return [];
    const keys = Object.keys(this.allProjects()) || [];
    const arr = keys.reduce((prev: UnifiedProject[], curr) => {
      if (this.allProjects()[curr] && this.allProjects()[curr].length) {
        return [...prev, ...this.allProjects()[curr]];
      }
      return [...prev];
    }, []);
    return arr;
  });

  constructor(
    public HELPER: HelperService,
  ) {
  }

  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;
}
